// Copyright (c) 2018 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import ClaimProcessInvoiceItem from './claim-process-invoice-item';
import Invoice from '@deere/cps-it.warranty-model-factory/lib/invoice';
import ListItemForm from './list-item-form';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../../shared/components/warranty-loading-indicator';

function handleCancelClick() {

    this.actions.cancelInvoiceSubmission();

}

function handleOnInvoiceAddition(file) {

    this.actions.updateClaimsProcess('file', file);

}

function handleOnInvoiceDelete(file) {

    this.actions.deleteFile(file);

}

function handleInvoiceNumberChange(dealerInvoiceNumber) {

    this.actions.updateClaimsProcess('dealerInvoiceNumber', dealerInvoiceNumber);

}

function handleInvoiceSubmission() {

    this.actions.updateDealerInvoices(this.invoice);

}

function handleInvoiceDateChange(dateOfDealerInvoice) {

    this.actions.updateClaimsProcess('dateOfDealerInvoice', dateOfDealerInvoice);

}

const ClaimProcessInvoice = props =>
    <div className='claim-process-invoice-view'>
        <WarrantyLoadingIndicator isLoading={props.busyCounter > 0}/>
        <ClaimProcessInvoiceItem
            dealer={props.invoice.dealer}
            invoice={props.invoice.claimsProcess}
            user={props.user}
        />
        <ListItemForm
            invoice={props.invoice}
            onCancelClick={props::handleCancelClick}
            onInvoiceAddition={props::handleOnInvoiceAddition}
            onInvoiceDelete={props::handleOnInvoiceDelete}
            onInvoiceNumberChange={props::handleInvoiceNumberChange}
            onInvoiceSubmission={props::handleInvoiceSubmission}
            onInvoicedDateChange={props::handleInvoiceDateChange}
        />
    </div>;

ClaimProcessInvoice.displayName = 'ClaimProcessInvoice';
ClaimProcessInvoice.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    invoice: PropTypes.instanceOf(Invoice).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default ClaimProcessInvoice;



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/components/claim-process-invoice/claim-process-invoice.js